import { Component, Input, OnChanges, SimpleChanges, ViewChild } from "@angular/core";

import { Contract, ContractProviders } from '../../../../../_models';
import { Product } from '../../../../../_models/Interfaces';
import { AgreementComponent } from '../agreement';


@Component({
    selector: 'app-contract',
    template: `
    	<app-agreement
    		[data]="data"
            [nameLabel]="'Folio'"
    		[selectionTexts]="contractTexts"
    		[texts]="texts"
    		[agreementIdKey]="'contract_id'"
    		[product]="product"

    	></app-agreement>
    `,
    providers: [ContractProviders]
})
export class ContractComponent implements OnChanges {
    @Input() unitId: number;
    @ViewChild(AgreementComponent) agreement: AgreementComponent;
    product: Product = {
        endpoint: 'unit',
        id: this.unitId
    };
    contractTexts = {
        label: "Asignar otro contrato",
        notFound: "Contrato no encontrado",
        loading: "Cargando contratos...",
        none: "Ningun contrato"
    }
    texts = {
        alertTitle: 'Contrato',
        alertText: 'Contrato guardado!',
        save: 'Guardar',
        upload: 'Subir archivo de nuevo',
        selectFile: 'Seleccione archivo',
        detail: 'Detalle',
        startDate: 'Fecha inicio',
        endDate: 'Fecha fin',
        amount: 'Precio de renta',
        signatory: 'Arrendatario'
    };
    constructor(private data: Contract) { }

    ngOnChanges(changes: SimpleChanges) {
        if ('unitId' in changes) {
            let unitId = changes['unitId'].currentValue;
            if (unitId) {
                this.product.id = unitId;
            }
        }
    }
    getData() {
        this.agreement.getThisAgreement();
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/units/contract/contract.component.ts